import { render, staticRenderFns } from "./IconRotate.vue?vue&type=template&id=85072420&"
import script from "./IconRotate.vue?vue&type=script&lang=js&"
export * from "./IconRotate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports